export class BaseClass {   
    id: number;
    dataLancamento: any;
    dataAtualizacao: any;
    statusMovimento: number;
    statusSincronizacao: number;
    observacoesSincronizacao: string;
    dataSincronizacao: any;
    createdBy: string;
    lastModifiedBy: string;
    codigoIntegracao: string;
    observacoesMovimento: string;
    userId: string;    

    constructor(base){

        this.id = base.id || 0;
        this.dataLancamento = base.dataLancamento || '';
        this.dataAtualizacao = base.dataAtualizacao || '';
        this.statusMovimento = base.statusMovimento || 0;
        this.statusSincronizacao = base.statusSincronizacao || 0;
        this.observacoesSincronizacao = base.observacoesSincronizacao || '';
        this.dataSincronizacao = base.dataSincronizacao || '';
        this.createdBy = base.createdBy || '';
        this.lastModifiedBy = base.lastModifiedBy || '';
        this.codigoIntegracao = base.codigoIntegracao || '';
        this.observacoesMovimento = base.observacoesMovimento || '';
        this.userId = base.userId || '';        
    }
}
